/**
 * Copyright 2021 Telekom Multimedia Solutions
 */

import 'lazysizes';

import BaseUseClass from 'Commons/js/baseUseClass';
import Global from 'Commons/js/global';
import Overlay from 'Components/overlay/overlay';
import PageHeader from 'Components/structure/pageheader/pageheader';
import PageFooter from 'Components/structure/pagefooter/pagefooter';
import MegaMenu from 'Components/structure/megamenu/megamenu';
import Tracking from '../../../clientlib-publish/src/js/tracking';

'use strict';

/**
 * STATE LOADING
 * Caution : HTMLElements may be missing at this points
 */

const baseUseClass = new BaseUseClass();

/** Latest jQuery */
if (window.$ === undefined || window.jQuery === undefined) {
    window.jQuery = require('jquery');
    window.$ = window.jQuery;
}

/**
 * STATE COMPLETE
 */
const stateCompleteCheckInterval = setInterval(() => {
    if (document.readyState === 'complete') {
    clearInterval(stateCompleteCheckInterval);

    /** Components */
    new Global(baseUseClass).init();

    new PageHeader(baseUseClass).init();
    new PageFooter(baseUseClass).init();
    new MegaMenu(baseUseClass).init();
    new Overlay(baseUseClass).init();
    new Tracking().init();
}
}, 10);
